import { motion } from "framer-motion";
import { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { FiEdit2, FiLoader } from "react-icons/fi";
import { IoIosInformationCircleOutline } from "react-icons/io";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useNotification } from "../../contextApi/NotificationProvider";
import {
    getUserDetails,
} from "../../redux/ReduxSlices/authSlice";
import { addNewPosition, getPositions, updatePosition } from "../../redux/ReduxSlices/openPositionsSlice";
import UpdatePositionPopup from "./UpdatePositionPopup";

const OpenPositions = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { showNotification } = useNotification();
    const { allPositions, loading, error } = useSelector(
        (state) => state.openPositions
    );

    const [descriptionModalOpen, setDescriptionModalOpen] = useState(false);
    const [selectedDescription, setSelectedDescription] = useState("");
    const { userData } = useSelector((state) => state.auth);
    const [editingPosition, setEditingPosition] = useState(null);
    const [openInfoPopup, setOpenInfoPopup] = useState(false)

    const handleDescriptionReadMore = (description) => {
        setSelectedDescription(description);
        setDescriptionModalOpen(true);
    };

    const handleDescriptionModalClose = () => {
        setDescriptionModalOpen(false);
        setSelectedDescription("");
    };

    const userInfo = userData?.company_info || {};
    const isCompanyEmailNotExist = userInfo.company_email === null;

    const {
        register,
        handleSubmit,
        watch,
        reset,
        setValue,
        getValues,
        formState: { errors },
    } = useForm();

    const [emailList, setEmailList] = useState([]);
    const [userEmail, setUserEmail] = useState("");
    const [emailError, setEmailError] = useState("");
    const [loader, setLoader] = useState(false);

    const inputRef = useRef(null);
    const visibility = watch("visibility");

    useEffect(() => {
        // dispatch(positionGetById());
        dispatch(getPositions());
        dispatch(getUserDetails());
    }, [dispatch]);

    const handleKeyDown = (e) => {
        if (e.key === "Enter" || e.key === ",") {
            e.preventDefault();
            const trimmed = userEmail.trim();
            if (
                trimmed &&
                /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmed) &&
                !emailList.includes(trimmed)
            ) {
                setEmailList([...emailList, trimmed]);
                setUserEmail("");
                setEmailError("");
            } else {
                setEmailError("Enter a valid and unique email");
            }
        }
    };

    const onSubmit = async (data) => {
        try {
            setLoader(true);
            const payload = {
                "job_title": data.job_title,
                "job_description": data.description,
                "other_info": data.other_details,
                "required_qualifications": data.required_qualifications,
                "industry_name": data.industry_name,
                "required_experience": data.required_experience,
                "number_of_position": data.number_of_position,
                "is_active": true
            };

            const response = await dispatch(addNewPosition(payload)).unwrap();
            console.log("res", response)
            if (response.success) {
                showNotification("New Position added successfully", "success", 3000);
                await dispatch(getPositions());
                reset();
            } else {
                showNotification("Something went wrong.", "error", 7000);
            }
        } catch (error) {
            console.error("Error submitting form:", error);
            showNotification(
                "Something went wrong while adding the position",
                "error",
                3000
            );
        } finally {
            setLoader(false);
        }
    };

    const updatePositionDetails = async (position) => {
        const payload = {
            "company_position_pk": position.company_position_pk,
            "job_title": position.job_title,
            "job_description": position.job_description,
            "other_info": position.other_info,
            "required_qualifications": position.required_qualifications,
            "industry_name": position.industry_name,
            "required_experience": position.required_experience,
            "number_of_position": position.number_of_position,
            "is_active": position.is_active
        }
        try {
            const response = await dispatch(updatePosition(payload)).unwrap()
            if (response.success) {
                await dispatch(getPositions())
                showNotification("Position updated successfully", "success", 3000);
            }
        } catch (error) {
            console.log("error", error)
        }
    }


    const toggleStatus = async (position) => {
        const payload = {
            "company_position_pk": position.company_position_pk,
            "job_title": position.job_title,
            "job_description": position.job_description,
            "other_info": position.other_info,
            "required_qualifications": position.required_qualifications,
            "industry_name": position.industry_name,
            "required_experience": position.required_experience,
            "number_of_position": position.number_of_position,
            "is_active": !position.is_active
        }
        updatePositionDetails(payload)

    };

    return (
        <div className="min-h-screen px-4 md:px-6 py-6 bg-gradient-to-br from-white to-gray-50">

            {loading && (
                <div className="fixed inset-0 z-50 flex items-center justify-center backdrop-blur-sm bg-black/30">
                    <FiLoader className="animate-spin text-[#822bda] text-4xl" />
                </div>
            )}

            <motion.h2 className="text-2xl font-bold text-start max-md:ml-10 px-4 max-md:p-0 flex items-center gap-4"
                initial={{ opacity: 0, y: -50 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, ease: "easeOut" }}
            >
                <span className="createPositions" >Create Positions</span>
                <button
                    onClick={() => setOpenInfoPopup(true)}
                    className="flex max-md:hidden text-xs items-center  text-blue-600 hover:text-blue-800 font-medium bg-blue-50 hover:bg-blue-100 px-3 max-md:px-1.5 py-1 rounded-full transition-colors"
                >
                    <IoIosInformationCircleOutline className="text-sm" />
                    <span className="ml-2 createPositionsInfo">Read Information</span>
                </button>
            </motion.h2>

            <button
                onClick={() => setOpenInfoPopup(true)}
                className="hidden max-md:flex items-center gap-1 mt-4 ml-10 text-xs text-blue-600 hover:text-blue-800 font-medium bg-blue-50 hover:bg-blue-100 px-3 max-md:px-1.5 py-1 rounded-full transition-colors"
            >
                <IoIosInformationCircleOutline className="text-sm" />
                <span>Read Information</span>
            </button>


            <div className="grid grid-cols-1 md:grid-cols-2 gap-10 max-md:gap-6 max-md:mt-3">
                {/* Left - Form */}
                <motion.form
                    onSubmit={handleSubmit(onSubmit)}
                    className="space-y-4 p-4 max-md:p-2 border-gray-100"
                    initial={{ opacity: 0, x: -50 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.6, ease: "easeOut" }}
                >
                    {/* <ul className="list-disc text-sm text-gray-600 mb-4 bg-violet-50 px-4 py-2 rounded-lg space-y-2 pl-6">
                        <li>
                            To have a vendor conduct assessments on your behalf through SelfSync.ai, you must first create a new position.
                        </li>
                        <li>
                            Once your vendor administers the test, the results will be automatically shared with you.
                        </li>
                        <li>
                            To proceed, simply open a new position by filling in the required details below.
                        </li>
                        <li>
                            Any previously opened positions will be displayed on the same page.
                        </li>
                    </ul> */}

                    <div>
                        <label className="block font-medium mb-1 text-base ">
                            Job Position Title <span className="text-red-500">*</span>
                        </label>
                        <input
                            {...register("job_title", {
                                required: "Position title is required",
                                validate: (value) =>
                                    value.trim() !== "" ||
                                    "Position title cannot be empty or just spaces",
                            })}
                            placeholder="e.g. Senior UI Designer"
                            className="w-full border border-gray-300 px-4 py-2 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-violet-500 transition placeholder:text-sm"
                        />
                        {errors.job_title && (
                            <p className="text-red-500 text-xs mt-1">
                                {errors.job_title.message}
                            </p>
                        )}
                    </div>

                    <div>
                        <label className="block font-medium mb-1 text-base">
                            Job Description <span className="text-red-500">*</span>
                        </label>
                        <p className="text-sm text-gray-500 mb-2">(Add a short description of the job profile to help others understand the role)</p>
                        <textarea
                            {...register("description", {
                                required: "Description is required",
                                validate: (value) =>
                                    value.trim() !== "" ||
                                    "Description cannot be empty or just spaces",
                            })}
                            rows={5}
                            placeholder="A few words about the role..."
                            className="w-full border border-gray-300 px-4 py-2 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-violet-500 transition placeholder:text-sm"
                        />
                        {errors.description && (
                            <p className="text-red-500 text-xs mt-1">
                                {errors.description.message}
                            </p>
                        )}
                    </div>
                    <div>
                        <label className="block font-medium mb-1 text-base ">
                            Other Details
                        </label>
                        <input
                            {...register("other_details")}
                            placeholder="e.g. Interested in AI-driven product development"
                            className="w-full border border-gray-300 px-4 py-2 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-violet-500 transition placeholder:text-sm"
                        />
                        {errors.other_details && (
                            <p className="text-red-500 text-xs mt-1">
                                {errors.other_details.message}
                            </p>
                        )}
                    </div>
                    <div>
                        <label className="block font-medium mb-1 text-base ">
                            Required Qualifications <span className="text-red-500">*</span>
                        </label>
                        <input
                            {...register("required_qualifications", {
                                required: "Please enter required qualifications"
                            })}
                            placeholder="e.g. BE, MCA"
                            className="w-full border border-gray-300 px-4 py-2 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-violet-500 transition placeholder:text-sm"
                        />
                        {errors.required_qualifications && (
                            <p className="text-red-500 text-xs mt-1">
                                {errors.required_qualifications.message}
                            </p>
                        )}
                    </div>
                    <div>
                        <label className="block font-medium mb-1 text-base ">
                            Industry <span className="text-red-500">*</span>
                        </label>
                        <input
                            {...register("industry_name", {
                                required: "Please enter industry."
                            })}
                            placeholder="e.g. Healthcare"
                            className="w-full border border-gray-300 px-4 py-2 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-violet-500 transition placeholder:text-sm"
                        />
                        {errors.industry_name && (
                            <p className="text-red-500 text-xs mt-1">
                                {errors.industry_name.message}
                            </p>
                        )}
                    </div>
                    <div>
                        <label className="block font-medium mb-1 text-base ">
                            Required Experience <span className="text-red-500">*</span>
                        </label>
                        <input
                            {...register("required_experience", {
                                required: "Please enter required experience.",
                                pattern: {
                                    value: /^[0-9]+$/,
                                    message: "Only numeric values are allowed",
                                },
                            })}
                            placeholder="e.g. 3"
                            className="w-full border border-gray-300 px-4 py-2 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-violet-500 transition placeholder:text-sm"
                        />

                        {errors.required_experience && (
                            <p className="text-red-500 text-xs mt-1">
                                {errors.required_experience.message}
                            </p>
                        )}
                    </div>
                    <div>
                        <label className="block font-medium mb-1 text-base ">
                            Number Of Positions <span className="text-red-500">*</span>
                        </label>
                        <input
                            {...register("number_of_position", {
                                required: "Please enter number of positions.",
                                pattern: {
                                    value: /^[0-9]+$/,
                                    message: "Only numeric values are allowed",
                                },
                            })}
                            placeholder="e.g. 3"
                            className="w-full border border-gray-300 px-4 py-2 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-violet-500 transition placeholder:text-sm"
                        />

                        {errors.number_of_position && (
                            <p className="text-red-500 text-xs mt-1">
                                {errors.number_of_position.message}
                            </p>
                        )}
                    </div>
                    <p className="block text-xs text-gray-600">
                        All fields marked with * are required.
                    </p>
                    <button
                        type="submit"
                        disabled={loader}
                        className={`btn-gradient text-white px-6 py-2 rounded-md shadow-md font-semibold transition-all ${loader ? "opacity-60 cursor-not-allowed" : ""
                            }`}
                    >
                        {loader ? "Please wait..." : "Open New Position"}
                    </button>
                </motion.form>

                {/* Right - Position List */}
                <motion.div className="space-y-4 h-[90vh] overflow-y-auto pr-2"
                    initial={{ opacity: 0, x: 50 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.6, ease: "easeOut" }}
                >
                    <h3 className="text-xl font-semibold text-gray-800 mb-2 positionsList">
                        Added Job Positions
                    </h3>

                    {error && <div className="text-red-500">{error.message}</div>}

                    {!allPositions || allPositions.length === 0 ? (
                        <p className="text-gray-500 text-center text-sm pt-12 max-md:pt-6 px-24 max-md:px-4">
                            You haven't added any positions yet. Start by adding one on the left—once you do, your posted positions will appear here.
                        </p>
                    ) : (
                        allPositions.map((pos, index) => (
                            <div
                                key={index}
                                className="bg-white p-3 rounded-xl shadow hover:shadow-lg transition-all border border-gray-200"
                            >
                                <div className="flex justify-between items-center mb-1">
                                    <h4 className="font-semibold text-md text-violet-700">
                                        <span>{pos.job_title.charAt(0).toUpperCase() + pos.job_title.slice(1)}</span>
                                    </h4>


                                    <div className="flex items-center gap-3">
                                        <span
                                            className={`text-xs font-medium px-3 py-1 rounded-full ${pos.is_active
                                                ? "bg-green-100 text-green-700" : "bg-red-100 text-red-600"

                                                }`}
                                        >
                                            {pos.is_active ? "active" : "Inactive"}
                                        </span>
                                        <button
                                            onClick={() => setEditingPosition(pos)}
                                            className="flex text-xs items-center gap-1.5 text-blue-600 hover:text-blue-800 font-medium bg-blue-50 hover:bg-blue-100 px-3 py-1 rounded-full transition-colors"
                                        >
                                            <FiEdit2 size={12} />
                                            <span>Update</span>
                                        </button>
                                        <button
                                            onClick={() => toggleStatus(pos)}
                                            className={`relative inline-flex h-6 w-12 items-center rounded-full ${pos.is_active ? "bg-green-400" : "bg-gray-300"
                                                }`}
                                        >
                                            <span
                                                className={`inline-block h-5 w-5 transform rounded-full bg-white transition-transform ${pos.is_active ? "translate-x-6" : "translate-x-1"
                                                    }`}
                                            />
                                        </button>
                                    </div>
                                </div>
                                <p className="text-sm text-gray-700">
                                    {pos.job_description?.length > 250
                                        ? `${pos.job_description.slice(0, 250)}...`
                                        : pos.job_description}
                                    {pos.job_description?.length > 250 && (
                                        <button
                                            onClick={() => handleDescriptionReadMore(pos.job_description)}
                                            className="text-violet-600 font-semibold ml-2 hover:underline text-sm"
                                        >
                                            Read More
                                        </button>
                                    )}
                                </p>
                                <p className="text-sm mt-2 text-gray-500">
                                    <span className="font-bold"> Other Information:{" "}</span>
                                    {pos.other_info?.length > 50
                                        ? `${pos.other_info.slice(0, 50)}...`
                                        : pos.other_info}
                                    {pos.other_info?.length > 50 && (
                                        <button
                                            onClick={() => handleDescriptionReadMore(pos.other_info)}
                                            className="text-violet-600 font-semibold ml-2 hover:underline text-sm"
                                        >
                                            Read More
                                        </button>
                                    )}
                                </p>
                                <div className="md:grid md:grid-cols-2">
                                    <div className="flex justify-start">
                                        <p className="text-sm mt-2 text-gray-500">
                                            Required Qualifications:{" "}
                                            <span className="font-sm text-xs bg-green-100 text-green-700 px-3 py-0.5 rounded-full">
                                                {pos.required_qualifications}
                                            </span>
                                        </p>
                                    </div>
                                    <div className="flex justify-start">
                                        <p className="text-sm mt-2 text-gray-500">
                                            Required Experience:{" "}
                                            <span className="font-sm text-xs bg-green-100 text-green-700 px-3 py-0.5 rounded-full">
                                                {pos.required_experience}
                                            </span>
                                        </p>
                                    </div>
                                    <div className="flex justify-start">
                                        <p className="text-sm mt-2 text-gray-500">
                                            Industry Name:{" "}
                                            <span className="font-sm text-xs bg-green-100 text-green-700 px-3 py-0.5 rounded-full">
                                                {pos.industry_name}
                                            </span>
                                        </p>
                                    </div>
                                    <div className="flex justify-start">
                                        <p className="text-sm mt-2 text-gray-500">
                                            Number Of Positions:{" "}
                                            <span className="font-sm text-xs bg-green-100 text-green-700 px-3 py-0.5 rounded-full">
                                                {pos.number_of_position}
                                            </span>
                                        </p>
                                    </div>
                                </div>


                            </div>
                        ))
                    )}
                </motion.div>
            </div>
            {descriptionModalOpen && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/30 backdrop-blur-sm p-4">
                    <motion.div
                        initial={{ scale: 0.7, opacity: 0 }}
                        animate={{ scale: 1, opacity: 1 }}
                        transition={{ duration: 0.3 }}
                        className="bg-white rounded-lg p-6 max-w-md w-full shadow-xl relative"
                    >
                        <button
                            onClick={handleDescriptionModalClose}
                            className="absolute top-5 right-4 text-gray-600 hover:text-gray-900 text-xl font-bold"
                        >
                            ✕
                        </button>
                        <h3 className="text-xl font-semibold mb-4 text-gray-800">
                            Full Job Description
                        </h3>
                        <p className="text-gray-500 text-base md:text-base leading-relaxed">
                            {selectedDescription}
                        </p>
                    </motion.div>
                </div>
            )}

            {
                openInfoPopup &&
                <div className="fixed inset-0 bg-black/40 backdrop-blur-sm bg-opacity-50 flex items-center justify-center z-50 p-4">
                    <motion.div
                        className="bg-white rounded-lg shadow-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto"
                        initial={{ opacity: 0, scale: 0.9 }}
                        animate={{ opacity: 1, scale: 1 }}
                        exit={{ opacity: 0, scale: 0.9 }}
                        transition={{ duration: 0.2 }}
                    >
                        <div className="p-6">
                            <div className="flex justify-between items-center mb-4">
                                <h3 className="text-xl font-semibold text-gray-800">Create Positions</h3>
                                <button
                                    onClick={() => setOpenInfoPopup(false)}
                                    className="text-gray-500 hover:text-gray-700"
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                    </svg>
                                </button>
                            </div>
                            <ul className="list-disc text-sm text-gray-600 mb-4  px-4 py-2 rounded-lg space-y-2 pl-6">
                                <li>
                                    To assign a position to New Hires in the Send Assessment section, you first need to create a new position for your company.
                                </li>
                                <li>
                                    Fill in the required fields below and click Open New Position to create a position.
                                </li>
                                <li>
                                    All created positions will be listed on the same page.
                                </li>
                                <li>
                                    Once a position is created, it will appear in the Enter Position dropdown under the New Hire section.
                                </li>
                                <li>
                                    You can deactivate a position after hiring someone for it by simply clicking the Deactivate button.
                                </li>
                            </ul>
                        </div>
                    </motion.div>
                </div>
            }

            {editingPosition && (
                <UpdatePositionPopup
                    position={editingPosition}
                    onClose={() => setEditingPosition(null)}
                    onUpdate={(payload) => updatePositionDetails(payload)}
                />
            )}
        </div>
    )
}

export default OpenPositions